import { ROUTES } from '../routes'

/** `/_/products/{productId}`: the product page / renewal checkout the access e-mails link to (F-74). */
export const PRODUCT_PATH_PREFIX = ROUTES.products
export const isProductPath = (path: string): boolean => path.startsWith(PRODUCT_PATH_PREFIX)

/** `/_/waitlist/{productId}`: where the member accepts a waitlist offer (F-74). */
export const WAITLIST_PATH_PREFIX = ROUTES.waitlist
export const isWaitlistPath = (path: string): boolean => path.startsWith(WAITLIST_PATH_PREFIX)

/** The id after a prefix, decoded; '' when missing. */
export const idAfter = (path: string, prefix: string): string =>
  decodeURIComponent(path.split('?')[0].slice(prefix.length).split('/')[0] || '')
